import {
    useEffect, useMemo, useRef, useState,
} from "react";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";
import Slide from "@mui/material/Slide";
import "./SnackbarToast.css";

const TransitionComponent = (props) => <Slide {...props} direction="up" />;

let toastQueue = [];

const SnackbarToast = (props) => {
    const {
        open, onClose, children,
        autoHideDuration = 5000,
        isSuccess, isError, isWarning,
    } = props;

    const [positionOffset, setPositionOffset] = useState(0);
    const toastRef = useRef(null);

    const severity = useMemo(() => {
        if (isSuccess) return "success";
        if (isError) return "error";
        if (isWarning) return "warning";
        return "info";
    }, [isSuccess, isError, isWarning]);

    const calculatePositions = () => {
        let cumulativeOffset = 0;

        toastQueue.forEach((toast) => {
            if (toast.ref.current) {
                const height = toast.ref.current.clientHeight || 0;
                toast.setOffset(cumulativeOffset);
                cumulativeOffset += height + 10;
            }
        });
    };

    useEffect(() => {
        if (open) {
            const newToast = { ref: toastRef, setOffset: setPositionOffset };
            toastQueue.push(newToast);

            calculatePositions();
        }

        return () => {
            toastQueue = toastQueue.filter((toast) => toast.ref !== toastRef);
            calculatePositions();
        };
    }, [open]);

    return (
        <Snackbar
            ref={toastRef}
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            TransitionComponent={TransitionComponent}
            transitionDuration={50}
            className="snackbar-toast"
            style={{ marginBottom: positionOffset }}
        >
            <Alert severity={severity} variant="outlined">
                {children}
            </Alert>
        </Snackbar>
    );
};

export default SnackbarToast;
